module.exports = __webpack_public_path__ + "img/Restore.15ff0f15.svg";